import React, { createContext, useContext, useCallback, useState } from "react";
import { App } from "antd";
import { showText } from "pdf-lib";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const { notification } = App.useApp();
  const [signalRNotification, setSignalRNotification] = useState(null);

  // ...existing code...
  const triggerNotification = useCallback(
    ({ type, message, description, statusCode, onProceed, onClose }) => {


      // Normalize and guard against non-string values
const msg = (message ?? '').toString().trim();
const desc = (description ?? '').toString().trim();

if (!desc) {
  console.warn("Notification description is required");
  return;
}

// guard: skip meaningless 'Error'/'Error' pairs (from backend generic error)
if (msg.toLowerCase() === 'error' && desc.toLowerCase() === 'error') {
  console.warn("Skipping redundant Error notification");
  return;
}

      const toText = (v) => {
        if (v === null || v === undefined) return "";
        if (typeof v === "string") return v;
        if (v instanceof Error) return v.message || String(v);
        try {
          return typeof v === "object" ? JSON.stringify(v) : String(v);
        } catch {
          return String(v);
        }
      };

      const msgText = toText(message) || (statusCode === 401 ? "Session expired" : "Notification");
      const descText = toText(description) || "";

      // Special handling for 401: show info with a single OK button
      if (statusCode === 401 && showText) {
        const okButton = (
          <div>
            <button
              style={{
                border: "none",
                background: "#1677ff",
                color: "white",
                padding: "5px 10px",
                cursor: "pointer",
                borderRadius: "4px",
              }}
              onClick={() => {
                if (onClose) onClose();
              }}
            >
              OK
            </button>
          </div>
        );

        notification.info({
          message: msgText,
          description: descText,
          btn: okButton,
          duration: 8,
        });
        return;
      }

      const actionButtons = (
        <div>
          {onProceed && (
            <button
              style={{
                marginRight: "8px",
                border: "none",
                background: "green",
                color: "white",
                padding: "5px 10px",
                cursor: "pointer",
                borderRadius: "4px",
              }}
              onClick={() => {
                if (onProceed) onProceed();
              }}
            >
              Proceed
            </button>
          )}
          {onClose && (
            <button
              style={{
                border: "none",
                background: "red",
                color: "white",
                padding: "5px 10px",
                cursor: "pointer",
                borderRadius: "4px",
              }}
              onClick={() => {
                if (onClose) onClose();
              }}
            >
              Close
            </button>
          )}
        </div>
      );

      notification[type || "open"]({
        message: msgText,
        description: descText,
        btn: actionButtons,
      });
    },
    [notification]
  );
  // const triggerNotification = useCallback(
  //   ({ type, message, description, statusCode, showAuth, onProceed, onClose }) => {

  //     //if message is not provided, just console log and return
  //     if (!message) {
  //       console.warn("Notification message is required");
  //       return;
  //     }
  //     // Define the action buttons if provided
  //     const actionButtons = (
  //       <div>
  //         {onProceed && (
  //           <button
  //             style={{
  //               marginRight: "8px",
  //               border: "none",
  //               background: "green",
  //               color: "white",
  //               padding: "5px 10px",
  //               cursor: "pointer",
  //               borderRadius: "4px",
  //             }}
  //             onClick={() => {
  //               if (onProceed) onProceed();
  //             }}
  //           >
  //             Proceed
  //           </button>
  //         )}
  //         {onClose && (
  //           <button
  //             style={{
  //               border: "none",
  //               background: "red",
  //               color: "white",
  //               padding: "5px 10px",
  //               cursor: "pointer",
  //               borderRadius: "4px",
  //             }}
  //             onClick={() => {
  //               if (onClose) onClose();
  //             }}
  //           >
  //             Close
  //           </button>
  //         )}
  //       </div>
  //     );

  //     // Special handling for 401: show info with a single OK button
  //     if (statusCode === 401 && showAuth) {
  //       const okButton = (
  //         <div>
  //           <button
  //             style={{
  //               border: "none",
  //               background: "#1677ff",
  //               color: "white",
  //               padding: "5px 10px",
  //               cursor: "pointer",
  //               borderRadius: "4px",
  //             }}
  //             onClick={() => {
  //               if (onClose) onClose();
  //             }}
  //           >
  //             OK
  //           </button>
  //         </div>
  //       );

  //       notification.info({
  //         message: message || "Session expired",
  //         description: description || "Your session has expired. You will be logged out.",
  //         btn: okButton,
  //         duration: 8,
  //       });
  //       return;
  //     }


  //     notification[type]({
  //       message,
  //       description,
  //       btn: actionButtons, // Add the custom buttons
  //     });
  //   },
  //   [notification]
  // );

  return (
    <NotificationContext.Provider
      value={{
        triggerNotification,
        signalRNotification,
        setSignalRNotification,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
